// eslint-disable-next-line no-restricted-exports, import/no-default-export
export {default} from '@bugsnag/js';
export * from '@bugsnag/js';
